import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import router from './routes'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import {BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(VueCookies)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

const store = new Vuex.Store({
  state: {
    user : undefined
  },
  mutations:{
    setUser (state, user) {
      console.log("setUser" + user)
      state.user = user
    }
  }
})

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})

